// Generated by BUCKLESCRIPT VERSION 2.1.0, PLEASE EDIT WITH CARE
'use strict';

var List       = require("bs-platform/lib/js/list.js");
var $$Array    = require("bs-platform/lib/js/array.js");
var Block      = require("bs-platform/lib/js/block.js");
var Js_math    = require("bs-platform/lib/js/js_math.js");
var Caml_array = require("bs-platform/lib/js/caml_array.js");
var Caml_int32 = require("bs-platform/lib/js/caml_int32.js");
var Pervasives = require("bs-platform/lib/js/pervasives.js");

var i = /* :: */[
  /* :: */[
    /* Blank */0,
    /* :: */[
      /* Blank */0,
      /* :: */[
        /* Blank */0,
        /* :: */[
          /* Blank */0,
          /* [] */0
        ]
      ]
    ]
  ],
  /* :: */[
    /* :: */[
      /* Full */[/* I */0],
      /* :: */[
        /* Full */[/* I */0],
        /* :: */[
          /* Full */[/* I */0],
          /* :: */[
            /* Full */[/* I */0],
            /* [] */0
          ]
        ]
      ]
    ],
    /* :: */[
      /* :: */[
        /* Blank */0,
        /* :: */[
          /* Blank */0,
          /* :: */[
            /* Blank */0,
            /* :: */[
              /* Blank */0,
              /* [] */0
            ]
          ]
        ]
      ],
      /* :: */[
        /* :: */[
          /* Blank */0,
          /* :: */[
            /* Blank */0,
            /* :: */[
              /* Blank */0,
              /* :: */[
                /* Blank */0,
                /* [] */0
              ]
            ]
          ]
        ],
        /* [] */0
      ]
    ]
  ]
];

function validateGame(game) {
  var testCells = function (_tCells, _wCells, _col) {
    while(true) {
      var col = _col;
      var wCells = _wCells;
      var tCells = _tCells;
      var match = +(col < game[/* tLeft */6]);
      var match$1 = +(col < 0);
      var exit = 0;
      if (tCells) {
        if (tCells[0]) {
          if (match$1 !== 0) {
            return /* false */0;
          } else if (wCells) {
            if (wCells[0]) {
              if (match !== 0) {
                exit = 1;
              } else {
                return /* false */0;
              }
            } else if (match !== 0) {
              exit = 1;
            } else {
              _col = col + 1 | 0;
              _wCells = wCells[1];
              _tCells = tCells[1];
              continue ;
              
            }
          } else {
            return /* false */0;
          }
        } else {
          var ts = tCells[1];
          if (match$1 !== 0) {
            _col = col + 1 | 0;
            _tCells = ts;
            continue ;
            
          } else if (wCells) {
            if (match !== 0) {
              exit = 1;
            } else {
              _col = col + 1 | 0;
              _wCells = wCells[1];
              _tCells = ts;
              continue ;
              
            }
          } else {
            _col = col + 1 | 0;
            _wCells = /* [] */0;
            _tCells = ts;
            continue ;
            
          }
        }
      } else {
        exit = 1;
      }
      if (exit === 1) {
        if (wCells) {
          if (match !== 0) {
            if (match$1 !== 0) {
              return /* true */1;
            } else {
              _col = col + 1 | 0;
              _wCells = wCells[1];
              continue ;
              
            }
          } else {
            return /* true */1;
          }
        } else {
          return /* true */1;
        }
      }
      
    };
  };
  var rowIsBlank = function (param) {
    return List.for_all((function (cell) {
                  return +(cell === /* Blank */0);
                }), param);
  };
  var _tRows = game[/* tetroid */4];
  var _wRows = game[/* well */0];
  var _row = Pervasives.min(game[/* tBottom */5], 0);
  while(true) {
    var row = _row;
    var wRows = _wRows;
    var tRows = _tRows;
    var match = +(row < game[/* tBottom */5]);
    var match$1 = +(row < 0);
    var exit = 0;
    if (tRows) {
      var ts = tRows[1];
      var t = tRows[0];
      if (match$1 !== 0) {
        if (rowIsBlank(t)) {
          _row = row + 1 | 0;
          _tRows = ts;
          continue ;
          
        } else {
          return /* false */0;
        }
      } else if (wRows) {
        if (match !== 0) {
          exit = 1;
        } else if (testCells(t, wRows[0], Pervasives.min(game[/* tLeft */6], 0))) {
          _row = row + 1 | 0;
          _wRows = wRows[1];
          _tRows = ts;
          continue ;
          
        } else {
          return /* false */0;
        }
      } else {
        _row = row + 1 | 0;
        _wRows = /* [] */0;
        _tRows = ts;
        continue ;
        
      }
    } else {
      exit = 1;
    }
    if (exit === 1) {
      if (wRows) {
        if (match !== 0) {
          if (match$1 !== 0) {
            return /* true */1;
          } else {
            _row = row + 1 | 0;
            _wRows = wRows[1];
            continue ;
            
          }
        } else {
          return /* true */1;
        }
      } else {
        return /* true */1;
      }
    }
    
  };
}

function genBag() {
  var ag = /* array */[
    i,
    /* :: */[
      /* :: */[
        /* Full */[/* J */1],
        /* :: */[
          /* Blank */0,
          /* :: */[
            /* Blank */0,
            /* [] */0
          ]
        ]
      ],
      /* :: */[
        /* :: */[
          /* Full */[/* J */1],
          /* :: */[
            /* Full */[/* J */1],
            /* :: */[
              /* Full */[/* J */1],
              /* [] */0
            ]
          ]
        ],
        /* :: */[
          /* :: */[
            /* Blank */0,
            /* :: */[
              /* Blank */0,
              /* :: */[
                /* Blank */0,
                /* [] */0
              ]
            ]
          ],
          /* [] */0
        ]
      ]
    ],
    /* :: */[
      /* :: */[
        /* Blank */0,
        /* :: */[
          /* Blank */0,
          /* :: */[
            /* Full */[/* L */2],
            /* [] */0
          ]
        ]
      ],
      /* :: */[
        /* :: */[
          /* Full */[/* L */2],
          /* :: */[
            /* Full */[/* L */2],
            /* :: */[
              /* Full */[/* L */2],
              /* [] */0
            ]
          ]
        ],
        /* :: */[
          /* :: */[
            /* Blank */0,
            /* :: */[
              /* Blank */0,
              /* :: */[
                /* Blank */0,
                /* [] */0
              ]
            ]
          ],
          /* [] */0
        ]
      ]
    ],
    /* :: */[
      /* :: */[
        /* Full */[/* O */3],
        /* :: */[
          /* Full */[/* O */3],
          /* [] */0
        ]
      ],
      /* :: */[
        /* :: */[
          /* Full */[/* O */3],
          /* :: */[
            /* Full */[/* O */3],
            /* [] */0
          ]
        ],
        /* [] */0
      ]
    ],
    /* :: */[
      /* :: */[
        /* Blank */0,
        /* :: */[
          /* Full */[/* S */4],
          /* :: */[
            /* Full */[/* S */4],
            /* [] */0
          ]
        ]
      ],
      /* :: */[
        /* :: */[
          /* Full */[/* S */4],
          /* :: */[
            /* Full */[/* S */4],
            /* :: */[
              /* Blank */0,
              /* [] */0
            ]
          ]
        ],
        /* :: */[
          /* :: */[
            /* Blank */0,
            /* :: */[
              /* Blank */0,
              /* :: */[
                /* Blank */0,
                /* [] */0
              ]
            ]
          ],
          /* [] */0
        ]
      ]
    ],
    /* :: */[
      /* :: */[
        /* Blank */0,
        /* :: */[
          /* Blank */0,
          /* :: */[
            /* Blank */0,
            /* [] */0
          ]
        ]
      ],
      /* :: */[
        /* :: */[
          /* Full */[/* T */5],
          /* :: */[
            /* Full */[/* T */5],
            /* :: */[
              /* Full */[/* T */5],
              /* [] */0
            ]
          ]
        ],
        /* :: */[
          /* :: */[
            /* Blank */0,
            /* :: */[
              /* Full */[/* T */5],
              /* :: */[
                /* Blank */0,
                /* [] */0
              ]
            ]
          ],
          /* [] */0
        ]
      ]
    ],
    /* :: */[
      /* :: */[
        /* Full */[/* Z */6],
        /* :: */[
          /* Full */[/* Z */6],
          /* :: */[
            /* Blank */0,
            /* [] */0
          ]
        ]
      ],
      /* :: */[
        /* :: */[
          /* Blank */0,
          /* :: */[
            /* Full */[/* Z */6],
            /* :: */[
              /* Full */[/* Z */6],
              /* [] */0
            ]
          ]
        ],
        /* :: */[
          /* :: */[
            /* Blank */0,
            /* :: */[
              /* Blank */0,
              /* :: */[
                /* Blank */0,
                /* [] */0
              ]
            ]
          ],
          /* [] */0
        ]
      ]
    ]
  ];
  var n = ag.length;
  for(var i$1 = n - 1 | 0; i$1 >= 1; --i$1){
    var k = Js_math.random_int(0, i$1 + 1 | 0);
    var x = Caml_array.caml_array_get(ag, k);
    Caml_array.caml_array_set(ag, k, Caml_array.caml_array_get(ag, i$1));
    Caml_array.caml_array_set(ag, i$1, x);
  }
  return $$Array.to_list(ag);
}

function spawn(ag) {
  var match = +(ag[/* bag */7] === /* [] */0);
  var bag = match !== 0 ? genBag(/* () */0) : ag[/* bag */7];
  var tetroid = List.hd(bag);
  var newBag = List.tl(bag);
  var newAg_000 = /* well */ag[/* well */0];
  var newAg_001 = /* lines */ag[/* lines */1];
  var newAg_002 = /* level */ag[/* level */2];
  var newAg_003 = /* score */ag[/* score */3];
  var newAg_005 = /* tBottom */22 - List.length(tetroid) | 0;
  var newAg_006 = /* tLeft */(10 - List.length(List.hd(tetroid)) | 0) / 2 | 0;
  var newAg = /* record */[
    newAg_000,
    newAg_001,
    newAg_002,
    newAg_003,
    /* tetroid */tetroid,
    newAg_005,
    newAg_006,
    /* bag */newBag
  ];
  var match$1 = validateGame(newAg);
  if (match$1 !== 0) {
    return /* Active */Block.__(0, [newAg]);
  } else {
    return /* Over */Block.__(1, [/* record */[
                /* well */ag[/* well */0],
                /* lines */ag[/* lines */1],
                /* level */ag[/* level */2],
                /* score */ag[/* score */3]
              ]]);
  }
}

function init() {
  return spawn(/* record */[
              /* well */$$Array.to_list($$Array.map($$Array.to_list, $$Array.make_matrix(20, 10, /* Blank */0))),
              /* lines */0,
              /* level */1,
              /* score */0,
              /* tetroid */i,
              /* tBottom */0,
              /* tLeft */0,
              /* bag */genBag(/* () */0)
            ]);
}

function getOverlaidBoard(ag) {
  var getCells = function (_tCells, wCells, _col) {
    while(true) {
      var col = _col;
      var tCells = _tCells;
      var match = +(col < ag[/* tLeft */6]);
      var match$1 = +(col < 0);
      var exit = 0;
      if (tCells) {
        var match$2 = tCells[0];
        if (match$1 !== 0) {
          _col = col + 1 | 0;
          _tCells = tCells[1];
          continue ;
          
        } else if (match$2) {
          if (wCells) {
            if (match !== 0) {
              exit = 1;
            } else {
              return /* :: */[
                      /* Full */[match$2[0]],
                      getCells(tCells[1], wCells[1], col + 1 | 0)
                    ];
            }
          } else {
            exit = 1;
          }
        } else if (wCells) {
          if (match !== 0) {
            exit = 1;
          } else {
            return /* :: */[
                    wCells[0],
                    getCells(tCells[1], wCells[1], col + 1 | 0)
                  ];
          }
        } else {
          exit = 1;
        }
      } else {
        exit = 1;
      }
      if (exit === 1) {
        if (wCells) {
          if (match !== 0 && match$1 === 0) {
            return /* :: */[
                    wCells[0],
                    getCells(tCells, wCells[1], col + 1 | 0)
                  ];
          } else {
            return wCells;
          }
        } else {
          return /* [] */0;
        }
      }
      
    };
  };
  var getRows = function (_tBottoms, wRows, _row) {
    while(true) {
      var row = _row;
      var tBottoms = _tBottoms;
      var match = +(row < ag[/* tBottom */5]);
      var match$1 = +(row < 0);
      var exit = 0;
      if (tBottoms) {
        var ts = tBottoms[1];
        if (match$1 !== 0) {
          _row = row + 1 | 0;
          _tBottoms = ts;
          continue ;
          
        } else if (wRows) {
          if (match !== 0) {
            exit = 1;
          } else {
            return /* :: */[
                    getCells(tBottoms[0], wRows[0], Pervasives.min(ag[/* tLeft */6], 0)),
                    getRows(ts, wRows[1], row + 1 | 0)
                  ];
          }
        } else {
          exit = 1;
        }
      } else {
        exit = 1;
      }
      if (exit === 1) {
        if (wRows) {
          if (match !== 0 && match$1 === 0) {
            return /* :: */[
                    wRows[0],
                    getRows(tBottoms, wRows[1], row + 1 | 0)
                  ];
          } else {
            return wRows;
          }
        } else {
          return /* [] */0;
        }
      }
      
    };
  };
  return getRows(ag[/* tetroid */4], ag[/* well */0], Pervasives.min(ag[/* tBottom */5], 0));
}

function getBoard(game) {
  if (game.tag) {
    return game[0][/* well */0];
  } else {
    return getOverlaidBoard(game[0]);
  }
}

function transpose(ls) {
  if (ls && ls[0]) {
    return /* :: */[
            List.map(List.hd, ls),
            transpose(List.map(List.tl, ls))
          ];
  } else {
    return /* [] */0;
  }
}

function all(x) {
  var xs = [];
  xs[0] = x;
  xs[1] = xs;
  return xs;
}

function take(n, ls) {
  if (ls && n !== 0) {
    return /* :: */[
            ls[0],
            take(n - 1 | 0, ls[1])
          ];
  } else {
    return /* [] */0;
  }
}

function padTrim(e, n, ls) {
  return take(n, Pervasives.$at(ls, all(e)));
}

function act(game, action) {
  if (game.tag) {
    return /* Over */Block.__(1, [game[0]]);
  } else {
    var ag = game[0];
    var potGame;
    switch (action) {
      case 0 : 
          var newrecord = ag.slice();
          newrecord[/* tLeft */6] = ag[/* tLeft */6] - 1 | 0;
          potGame = newrecord;
          break;
      case 1 : 
          var newrecord$1 = ag.slice();
          newrecord$1[/* tLeft */6] = ag[/* tLeft */6] + 1 | 0;
          potGame = newrecord$1;
          break;
      case 2 : 
          var newrecord$2 = ag.slice();
          newrecord$2[/* tetroid */4] = transpose(List.rev(ag[/* tetroid */4]));
          potGame = newrecord$2;
          break;
      case 3 : 
          var newrecord$3 = ag.slice();
          newrecord$3[/* tetroid */4] = List.rev(transpose(ag[/* tetroid */4]));
          potGame = newrecord$3;
          break;
      case 4 : 
          var newrecord$4 = ag.slice();
          newrecord$4[/* tBottom */5] = ag[/* tBottom */5] - 1 | 0;
          potGame = newrecord$4;
          break;
      case 5 : 
          var findBottom = function (_validAg) {
            while(true) {
              var validAg = _validAg;
              var newrecord = validAg.slice();
              newrecord[/* tBottom */5] = validAg[/* tBottom */5] - 1 | 0;
              var match = validateGame(newrecord);
              if (match !== 0) {
                _validAg = newrecord;
                continue ;
                
              } else {
                return validAg;
              }
            };
          };
          potGame = findBottom(ag);
          break;
      
    }
    var match = validateGame(potGame);
    if (match !== 0) {
      return /* Active */Block.__(0, [potGame]);
    } else if (action >= 4) {
      var packedWell = List.filter((function (param) {
                return List.exists((function (cell) {
                              return +(cell === /* Blank */0);
                            }), param);
              }))(getOverlaidBoard(ag));
      var lines = 20 - List.length(packedWell) | 0;
      var match$1 = +((ag[/* lines */1] + lines | 0) <= Caml_int32.imul(ag[/* level */2], 3));
      var level = match$1 !== 0 ? ag[/* level */2] : ag[/* level */2] + 1 | 0;
      var switcher = lines - 1 | 0;
      var tmp;
      if (switcher > 3 || switcher < 0) {
        tmp = 0;
      } else {
        switch (switcher) {
          case 0 : 
              tmp = 100;
              break;
          case 1 : 
              tmp = 300;
              break;
          case 2 : 
              tmp = 500;
              break;
          case 3 : 
              tmp = 800;
              break;
          
        }
      }
      var score = ag[/* score */3] + Caml_int32.imul(level, tmp) | 0;
      var well = padTrim($$Array.to_list(Caml_array.caml_make_vect(10, /* Blank */0)), 20, packedWell);
      return spawn(/* record */[
                  /* well */well,
                  /* lines */ag[/* lines */1] + lines | 0,
                  /* level */level,
                  /* score */score,
                  /* tetroid */ag[/* tetroid */4],
                  /* tBottom */ag[/* tBottom */5],
                  /* tLeft */ag[/* tLeft */6],
                  /* bag */ag[/* bag */7]
                ]);
    } else {
      return game;
    }
  }
}

function getLevel(game) {
  return game[0][/* level */2];
}

function getScore(game) {
  return game[0][/* score */3];
}

function getLines(game) {
  return game[0][/* lines */1];
}

function isActive(game) {
  if (game.tag) {
    return /* false */0;
  } else {
    return /* true */1;
  }
}

exports.init     = init;
exports.act      = act;
exports.isActive = isActive;
exports.getBoard = getBoard;
exports.getLevel = getLevel;
exports.getLines = getLines;
exports.getScore = getScore;
/* No side effect */



//////////////////
// WEBPACK FOOTER
// ./src/lib/Tetris.re
// module id = 41
// module chunks = 0